import React, { Component } from 'react'
import PropTypes            from 'prop-types';
import PlaceImage           from './PlaceImage';
import PlaceBody            from './Place/PlaceBody';

class PageContent extends Component
{

    render = () => 
    {
        let { page } = this.props;

        return (
            <div>
                <PlaceImage place={ page } />
                <h3>{ page.name }</h3>
                <PlaceBody body={ page.body } />
            </div>
        );
    }

}

PageContent.props = {
    page: PropTypes.object.isRequired
};

export default PageContent;



// WEBPACK FOOTER //
// ./src/components/PageContent.js